export default "__VITE_ASSET__CzjMZzrC__"